import type { TPricing } from "~/components/cards/Pricing.vue";

export const webchatPrices: Array<TPricing> = [
    {
      title: "مناسب تمام سایت‌ها",
      img: "/img/new/pricing/advance.webp",
      amounts: [
        { title: "به ازای هر ماه/ پرداخت سالانه", value: "450", unit: "هزار تومان" },
      ],
      features: [
        { title: "دریافت و پاسخگویی به پیام‌ها در اپلیکیشن", value: true },
        { title: "شخصی‌سازی باکس گفتگو متناسب با تم سایت", value: true },
      ]
    },
];